import { AnprVM } from 'shell/view-models/search-anpr';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { PersonVM } from 'shell/view-models/search-person';
import { DateTime } from 'luxon';
import { AxiosResponse } from 'axios';

export const transformerPersonList = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): AnprVM<PersonVM> => {
  return {
    warningInformation: response.data.payload.warning || undefined,
    warnings: (response.data.payload?.risposta3002OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (response.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: (response.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || []).map(
      (person, index) => {
        const residenceArray = person.residenza || [];

        let birthplace = '';
        // birthplace check for object
        if (person.generalita?.luogoNascita?.localita) {
          birthplace = `${person.generalita?.luogoNascita?.localita.descrizioneLocalita} (${person.generalita?.luogoNascita?.localita.descrizioneStato})`;
        }

        if (person.generalita?.luogoNascita?.comune) {
          birthplace = `${person.generalita?.luogoNascita?.comune.nomeComune} (${person.generalita?.luogoNascita?.comune.siglaProvinciaIstat})`;
        }
        // Residence check for object
        let residence = '';
        // scelgo il primo o è un array?
        if (residenceArray[0]?.indirizzo) {
          residence = `${residenceArray[0]?.indirizzo.comune?.nomeComune || ''} (${
            residenceArray[0]?.indirizzo.comune?.siglaProvinciaIstat || ''
          })`;
        }
        // scelgo il primo o è un array?
        if (residenceArray[0]?.localitaEstera) {
          residence = `${residenceArray[0]?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita} (${residenceArray[0]?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato})`;
        }

        let state = '';
        let address = '';
        // state check for object
        if (residenceArray[0]?.indirizzo?.toponimo) {
          const toponym = residenceArray[0]?.indirizzo?.toponimo;

          const civic = residenceArray[0]?.indirizzo?.numeroCivico;

          state = `${toponym?.specie || ''} ${toponym?.denominazioneToponimo || ''},${
            civic?.numero || ''
          }${civic?.esponente1 ? `/${civic.esponente1 || ''}${civic.lettera || ''}` : ''}`;
          address = `${toponym?.specie || ''} ${toponym?.denominazioneToponimo || ''},${
            civic?.numero || ''
          }${civic?.esponente1 ? `/${civic.esponente1 || ''}${civic.lettera || ''}` : ''}`;
        }

        if (person.generalita?.soggettoAIRE && person.generalita?.soggettoAIRE === 'S') {
          state = 'Iscritto AIRE';
          if (residenceArray[0]?.localitaEstera?.indirizzoEstero?.toponimo) {
            const toponym = residenceArray[0]?.localitaEstera?.indirizzoEstero?.toponimo;

            const civic =
              residenceArray[0]?.localitaEstera?.indirizzoEstero?.toponimo?.numeroCivico;

            address = `${toponym?.denominazione || ''},${civic || ''}`;
          }
        }

        if (person.datiCancellazione && person.datiCancellazione?.descrizioneMotivoCancellazione) {
          state = `${person.datiCancellazione.descrizioneMotivoCancellazione}`;
        }

        let statePerson = '';
        // state check for object
        if (residenceArray[0]?.indirizzo?.toponimo) {
          statePerson = 'Residente';
        }
        if (person.generalita?.soggettoAIRE && person.generalita?.soggettoAIRE === 'S') {
          statePerson = 'Iscritto AIRE';
        }
        if (person.datiCancellazione && person.datiCancellazione?.descrizioneMotivoCancellazione) {
          statePerson = `${person.datiCancellazione.descrizioneMotivoCancellazione}`;
        }

        return {
          generality: person.generalita,
          citizenship: person.cittadinanza || undefined,
          residenceAll: person.residenza || undefined,
          residence,
          statePerson,
          code: person.generalita?.codiceFiscale?.codFiscale || (index + 1).toString(),
          fiscalCode: person.generalita?.codiceFiscale?.codFiscale || '',
          surname: person.generalita?.cognome || '',
          name: person.generalita?.nome || '',
          gender: person.generalita?.sesso || '',
          birthday: person.generalita?.dataNascita
            ? DateTime.fromISO(person.generalita.dataNascita).toFormat('dd/MM/yyyy')
            : '',
          birthplace,
          state,
          address,
          anpr: person.generalita?.idSchedaSoggettoANPR || '',
          idFamilyAnpr: person.famigliaConvivenza?.idFamigliaConvivenzaANPR || '',
          idSchedaSoggettoComune: person.generalita?.idSchedaSoggettoComune || '',
          codicePersonaSipo: person.codicePersonaSipo || '',
          dati3002: response.data.payload,
          hidden: {
            delete: true,
            edit: true,
          },
        };
      }
    ) as Array<PersonVM>,
  };
};
